<template>
  <div class="app-container">
    <div class="filter-container">
      <el-button
        v-if="$canEdit"
        size="small"
        class="filter-item"
        type="primary"
        @click="addLog"
        >生成台账
      </el-button>
      台账账期:
      <el-date-picker
        size="small"
        class="filter-item"
        v-model="dateArr1"
        type="monthrange"
        :default-time="['00:00:00', '23:59:59']"
        value-format="yyyy-MM"
        unlink-panels
        range-separator="至"
        start-placeholder="开始时间"
        end-placeholder="结束时间"
      ></el-date-picker>
      创建时间:
      <el-date-picker
        size="small"
        class="filter-item"
        v-model="dateArr"
        type="daterange"
        :default-time="['00:00:00', '23:59:59']"
        align="right"
        value-format="yyyy-MM-dd"
        unlink-panels
        range-separator="至"
        start-placeholder="开始时间"
        end-placeholder="结束时间"
      ></el-date-picker>
      <el-button
        class="filter-item"
        type="primary"
        icon="el-icon-search"
        @click="handleFilter"
        size="small"
        >搜索
      </el-button>
    </div>
    <el-table
      v-loading="listLoading"
      :data="list"
      :row-class-name="tableRowClassName"
      element-loading-text="Loading"
      border
      fit
      highlight-current-row
    >
      <el-table-column align="center" label="序号">
        <template slot-scope="scope">
          {{ scope.$index + 1 }}
        </template>
      </el-table-column>
      <el-table-column align="center" label="台账账期">
        <template slot-scope="scope">
          {{ moment(scope.row.settlement_date).format('YYYY-MM') }}
        </template>
      </el-table-column>
      <el-table-column
        align="center"
        label="总锦江渠道价实际账期"
        min-width="100"
      >
        <template slot-scope="scope">
          {{ scope.row.jin_jiang_total_actual_channel_money || '-' }}
        </template>
      </el-table-column>
      <el-table-column
        align="center"
        label="总龙腾渠道价实际账期"
        min-width="100"
      >
        <template slot-scope="scope">
          {{ scope.row.long_teng_total_actual_channel_money || 0 }}
        </template>
      </el-table-column>
      <el-table-column
        align="center"
        label="总遂穿渠道价实际账期"
        min-width="100"
      >
        <template slot-scope="scope">
          {{ scope.row.sui_chuan_total_actual_channel_money || 0 }}
        </template>
      </el-table-column>
      <el-table-column align="center" label="渠道价账期总计">
        <template slot-scope="scope">
          {{ scope.row.sum_actual_channel_money }}
        </template>
      </el-table-column>
      <el-table-column align="center" label="补差总计" width="120px">
        <template slot-scope="scope">
          {{ scope.row.sum_make_up_diff || '-' }}
        </template>
      </el-table-column>
      <el-table-column align="center" label="应付总计金额" width="120px">
        <template slot-scope="scope">
          {{ scope.row.sum_total_money || '-' }}
        </template>
      </el-table-column>
      <el-table-column align="center" label="已扣额度总计">
        <template slot-scope="scope">
          {{ scope.row.total_quota_value }}
        </template>
      </el-table-column>
      <el-table-column align="center" label="账期成本总计">
        <template slot-scope="scope">
          {{ scope.row.sum_actual_total_rate }}
        </template>
      </el-table-column>
      <el-table-column
        align="center"
        label="总锦江实际账期成本"
        min-width="100"
      >
        <template slot-scope="scope">
          {{ scope.row.jin_jiang_total_actual_cost || '-' }}
        </template>
      </el-table-column>
      <el-table-column
        align="center"
        label="总龙腾实际账期成本"
        min-width="100"
      >
        <template slot-scope="scope">
          {{ scope.row.long_teng_total_actual_cost || '-' }}
        </template>
      </el-table-column>
      <el-table-column
        align="center"
        label="总遂穿实际账期成本"
        min-width="100"
      >
        <template slot-scope="scope">
          {{ scope.row.sui_chuan_total_actual_cost || '-' }}
        </template>
      </el-table-column>

      <el-table-column align="center" label="订单数">
        <template slot-scope="scope">
          {{ scope.row.order_num }}
        </template>
      </el-table-column>
      <el-table-column align="center" label="本月充值总计" width="120px">
        <template slot-scope="scope">
          {{ scope.row.total_recharge_money }}
        </template>
      </el-table-column>
      <el-table-column
        class-name="status-col"
        label="状态"
        min-width="110"
        align="center"
      >
        <template slot-scope="scope">
          <el-tag v-if="scope.row.status == 'completed'" type="success"
            >已完成</el-tag
          >
          <el-tag v-else type="warning">已撤回</el-tag>
        </template>
      </el-table-column>
      <el-table-column label="操作人员" min-width="110" align="center">
        <template slot-scope="scope">
          {{ scope.row.admin ? scope.row.admin.username : '-' }}
        </template>
      </el-table-column>
      <el-table-column align="center" label="创建时间">
        <template slot-scope="scope">
          {{ scope.row.created_at }}
        </template>
      </el-table-column>
      <el-table-column
        v-if="$canEdit"
        fixed="right"
        label="操作"
        min-width="140"
        align="center"
        class-name="small-padding fixed-width"
      >
        <template slot-scope="scope">
          <div style="margin-top: 5px">
            <el-button
              v-if="scope.row.status != 'revoked'"
              size="mini"
              type="warning"
              @click="revoke(scope.row)"
            >
              撤回
            </el-button>
          </div>
          <div style="margin-top: 5px">
            <el-button
              size="mini"
              type="success"
              @click="handleUpdateLog(scope.row)"
            >
              更新台账
            </el-button>
          </div>
          <div style="margin-top: 5px">
            <el-button
              size="mini"
              type="warning"
              @click="handleBatchSendEmail(scope.row)"
            >
              一键邮箱通知
            </el-button>
          </div>
        </template>
      </el-table-column>
    </el-table>

    <div class="pagination-container">
      <el-pagination
        :current-page="listQuery.page"
        :page-sizes="[10, 20, 30, 50]"
        :page-size="listQuery.limit"
        :total="total"
        background
        layout="total, sizes, prev, pager, next, jumper"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
      />
    </div>
    <el-dialog
      title="生成台账"
      :visible.sync="showaddLog"
      :close-on-click-modal="false"
      :destroy-on-close="true"
      append-to-body
      width="512px"
    >
      <el-form
        ref="addLogform"
        :model="addLogform"
        :rules="addLogRules"
        label-width="140px"
      >
        <el-form-item label="台账账期" prop="img">
          <el-date-picker
            size="small"
            v-model="addLogform.settlement_date"
            type="month"
            value-format="yyyy-MM"
            placeholder="选择台账账期"
          >
          </el-date-picker>
          <el-button
            class="filter-item"
            type="primary"
            icon="el-icon-search"
            @click="getCount"
            size="small"
            style="margin-left: 5px"
            :loading="getCountBtnLoading"
            >检索
          </el-button>
        </el-form-item>
        <el-form-item label="总账期成本" prop="img">
          {{ data.total_actual_total_rate }}
        </el-form-item>
        <el-form-item label="总龙腾实际账期成本" prop="img">
          {{ data.long_teng_actual_total_rate }}
        </el-form-item>
        <el-form-item label="总锦江实际账期成本" prop="img">
          {{ data.jin_jiang_actual_total_rate }}
        </el-form-item>
        <el-form-item label="总遂穿实际账期成本" prop="img">
          {{ data.sui_chuan_actual_total_rate }}
        </el-form-item>

        <el-form-item label="总渠道价实际账期" prop="img">
          {{ data.total_actual_channel_money }}
        </el-form-item>
        <el-form-item label="总龙腾实际账期" prop="img">
          {{ data.long_teng_actual_channel_money }}
        </el-form-item>
        <el-form-item label="总锦江实际账期" prop="img">
          {{ data.jin_jiang_actual_channel_money }}
        </el-form-item>
        <el-form-item label="总充值金额" prop="img">
          {{ data.total_recharge_money }}
        </el-form-item>
        <el-row type="flex" justify="end">
          <el-button @click="showaddLog = false">取消</el-button>
          <el-button type="primary" @click="postaddLog">确认</el-button>
        </el-row>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
import request from '@/utils/request'
import downloadExcel from 'vue-json-excel'
import { excel2Json } from '@/utils/excel'
import moment from 'moment'

export default {
  components: { downloadExcel },
  data() {
    return {
      showaddLog: false,
      addLogRules: {
        reason: [
          { required: true, message: '请填写驳回理由', trigger: 'blur' },
        ],
      },
      addLogform: {
        users: [],
        date: '',
        start_date: '',
        end_date: '',
      },
      data: {
        total_actual_total_rate: 0,
        jin_jiang_actual_total_rate: 0,
        jin_jiang_actual_channel_money: 0,
        long_teng_actual_total_rate: 0,
        long_teng_actual_channel_money: 0,
        sui_chuan_actual_total_rate: 0,
        sui_chuan_actual_channel_money: 0,
        total_actual_channel_money: 0,
        total_recharge_money: 0,
      },
      list: null,
      total: null,
      listLoading: false,
      exportLoading: false,
      listQuery: {
        page: 1,
        limit: 10,
        start_at: '',
        end_at: '',
      },
      userLogsid: '',
      viplist: [],
      json_fields: {
        发放人数: {
          field: 'user_num',
          //自定义回调函数
          callback: (value) => {
            return '<p style="mso-number-format:\'\\@\';">' + value + '</p>'
          },
        },
        发放时间: {
          field: 'created_at',
          //自定义回调函数
          callback: (value) => {
            return '<p style="mso-number-format:\'\\@\';">' + value + '</p>'
          },
        },
      },
      json_fields2: {
        用户名: {
          field: 'username',
          //自定义回调函数
          callback: (value) => {
            return '<p style="mso-number-format:\'\\@\';">' + value + '</p>'
          },
        },
        用户id: {
          field: 'user_id',
          //自定义回调函数
          callback: (value) => {
            return '<p style="mso-number-format:\'\\@\';">' + value + '</p>'
          },
        },
        奖励金额: {
          field: 'reward_value',
          //自定义回调函数
          callback: (value) => {
            return '<p style="mso-number-format:\'\\@\';">' + value + '</p>'
          },
        },
        备注: {
          field: 'remark',
          //自定义回调函数
          callback: (value) => {
            return '<p style="mso-number-format:\'\\@\';">' + value + '</p>'
          },
        },
      },
      dateArr: null,
      dateArr1: null,
      getCountBtnLoading: false,
    }
  },
  created() {
    this.getList()
  },
  watch: {
    showaddLog() {
      this.addLogform = {
        jin_jiang_orders: [],
        date: '',
        end_travel_date_start_at: '',
        end_travel_date_end_at: '',
      }
    },
    dateArr(newVal, oldVal) {
      if (newVal) {
        this.listQuery.start_at = newVal[0]
        this.listQuery.end_at = newVal[1]
      } else {
        this.listQuery.start_at = ''
        this.listQuery.end_at = ''
      }
    },
    dateArr1(newVal, oldVal) {
      if (newVal) {
        this.listQuery.settlement_date_start_at = newVal[0]
        this.listQuery.settlement_date_end_at = newVal[1]
      } else {
        this.listQuery.settlement_date_start_at = ''
        this.listQuery.settlement_date_end_at = ''
      }
    },
  },
  computed: {
    moment() {
      return moment
    },
    //状态：none：未处理 ； pending：处理中 ；completed：已完成； revoke_pending ：撤销处理中；revoked：已撤销
    status() {
      return (val) => {
        switch (val) {
          case 'none':
            return '未处理'
          case 'pending':
            return '处理中'
          case 'completed':
            return '已完成'
          case 'revoke_pending':
            return '撤销处理中'
          case 'revoked':
            return '已撤销'
        }
      }
    },
    revenue_type() {
      return (val) => {
        switch (val) {
          case 'retail_bonus':
            return '零售奖励'
          case 'referral_bonus':
            return '推荐奖励'
          case 'distribution_bonus':
            return '分销奖励'
          case 'expansion_bonus':
            return '级差奖励'
          case 'welfare_bonus':
            return '福利奖励'
          case 'founder_bonus':
            return '创始人分红'
          case 'vip_bonus':
            return 'VIP 分红'
          case 'super_vip_bonus':
            return '钻石分红'
        }
      }
    },
  },
  methods: {
    tableRowClassName({ row }) {
      const systemCost = Number(row.system_cost)
      const jinJiangCost = Number(row.jin_jiang_cost)

      if (systemCost === 0) {
        console.log(systemCost)
        return 'row-red'
      }

      if (jinJiangCost === 0) {
        return 'row-blue'
      }

      if (systemCost > 0 && jinJiangCost > 0 && systemCost !== jinJiangCost) {
        return 'row-yellow'
      }

      return ''
    },

    addLog() {
      this.showaddLog = true
    },
    downloadExcel() {
      let a = document.createElement('a')
      a.href = '/订单对账模板.xlsx'
      a.download = '订单对账模板.xlsx'
      a.style.display = 'none'
      document.body.appendChild(a)
      a.click()
      a.remove()
    },
    postaddLog() {
      if (!this.addLogform.settlement_date) {
        this.$message.warning('请选择台账账期')
        return
      }
      return request({
        url: '/api/backend/ledger/create-log',
        method: 'POST',
        data: this.addLogform,
      })
        .then((res) => {
          if (res.code == 0) {
            this.$message({
              type: 'success',
              message: '操作成功',
            })
            this.showaddLog = false
            this.getList()
          }
        })
        .finally((val) => {
          console.log(val)
        })
    },
    handleImportUsers(file) {
      this.addLogform.users = []
      file = file.raw
      if (
        !(file.name.split('.')[1] == 'xlsx' || file.name.split('.')[1] == 'xls')
      ) {
        this.$message.error('上传文件格式不正确，请检查选择的文件')
        return
      }
      excel2Json(file, 1).then((excelData) => {
        console.log(excelData)
        // 处理业务
        if (excelData.length <= 0) {
          this.$message.error('数据不能为空')
          return
        }
        excelData.forEach((element, index) => {
          if (element['锦江订单号']) {
            this.addLogform.jin_jiang_orders.push({
              order_code: element['锦江订单号'],
              total_rate: element['锦江支付总价'],
            })
          }
          console.log(element, '--------', index)
        })
        this.importDataDialogVisible = true
        console.log(this.addLogform.jin_jiang_orders, '=============')
      })
    },
    changedata(val) {
      console.log(val)
      if (val) {
        this.listQuery.start_at = val[0]
        this.listQuery.end_at = val[1]
      } else {
        this.listQuery.start_at = ''
        this.listQuery.end_at = ''
      }
    },
    changeaddLogformdata(val) {
      console.log(val)
      if (val) {
        this.addLogform.end_travel_date_start_at = val[0]
        this.addLogform.end_travel_date_end_at = val[1]
      } else {
        this.addLogform.end_travel_date_start_at = ''
        this.addLogform.end_travel_date_end_at = ''
      }
    },
    handleExport() {
      if (!this.listQuery.start_at || !this.listQuery.end_at) {
        this.$message.warning('请选择开始与结束日期')
        return
      }
      this.exportLoading = true
      var listQuery = JSON.parse(JSON.stringify(this.listQuery))
      return request({
        url: '/api/backend/globalReward/logs',
        method: 'get',
        params: listQuery,
      })
        .then((response) => {
          console.log(response)
          return response.data.data
        })
        .finally((val) => {
          console.log(val)
          this.exportLoading = false
        })
    },
    handleExport2() {
      this.exportLoading = true
      return request({
        url: '/api/backend/globalReward/userLogs',
        method: 'get',
        params: {
          id: this.userLogsid,
        },
      })
        .then((response) => {
          console.log(response)
          return response.data.data
        })
        .finally((val) => {
          console.log(val)
          this.exportLoading = false
        })
    },
    getList() {
      this.listLoading = true
      request({
        url: '/api/backend/ledger/list',
        method: 'get',
        params: this.listQuery,
      }).then((response) => {
        this.list = response.data.data
        this.total = response.data.total
        this.listLoading = false
      })
    },
    handleFilter() {
      this.listQuery.page = 1
      this.getList()
    },
    handleSizeChange(val) {
      this.listQuery.limit = val
      this.getList()
    },
    handleCurrentChange(val) {
      this.listQuery.page = val
      this.getList()
    },
    getCount() {
      if (this.addLogform.settlement_date == null) {
        return
      }
      this.getCountBtnLoading = false
      request({
        url: '/api/backend/ledger/getCount',
        method: 'get',
        params: {
          settlement_date: this.addLogform.settlement_date,
        },
      })
        .then((response) => {
          if (response.data) {
            this.data = response.data
          }
        })
        .finally(
          () =>
            function () {
              this.getCountBtnLoading = false
            },
        )
    },
    handleBatchSendEmail(row) {
      this.$confirm('确认发送一键邮箱通知？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          request({
            url: '/api/backend/ledger/batch-send-email-notification',
            method: 'post',
            data: {
              ledger_log_id: row.id,
              send_to: 'all',
            },
          }).then((res) => {
            if (res.code == 0) {
              this.$message({
                type: 'success',
                message: '发送成功',
              })
            }
          })
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消',
          })
        })
    },
    revoke(row) {
      this.$confirm('是否确认撤回？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          request({
            url: '/api/backend/ledger/revoke',
            method: 'post',
            data: {
              id: row.id,
            },
          }).then((res) => {
            console.log(res)
            if (res.code == 0) {
              this.$message({
                type: 'success',
                message: '操作成功',
              })
              this.getList()
            }
          })
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消',
          })
        })
    },
    handleUpdateLog(row) {
      this.$msgbox({
        title: '提示',
        message: '是否确认更新台账？更新后将重新计算台账数据。',
        showCancelButton: true,
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        beforeClose: (action, instance, done) => {
          if (action === 'confirm') {
            instance.confirmButtonLoading = true
            instance.confirmButtonText = '执行中...'
            request({
              url: '/api/backend/ledger/update-log',
              method: 'post',
              data: {
                settlement_date: row.settlement_date,
              },
            })
              .then((res) => {
                if (res.code == 0) {
                  done()
                  instance.confirmButtonLoading = false
                  this.$message({
                    type: 'success',
                    message: '更新成功',
                  })
                  this.getList()
                } else {
                  done()
                  instance.confirmButtonLoading = false
                }
              })
              .catch(() => {
                done()
                instance.confirmButtonLoading = false
              })
          } else {
            instance.confirmButtonLoading = false
            done()
          }
        },
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消',
        })
      })
    },
  },
}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
.user-avatar {
  width: 40px;
  height: 40px;
  border-radius: 6px;
}

::v-deep .row-red {
  background-color: #ffecec !important;
}

::v-deep .row-blue {
  background-color: #e0f0ff !important;
}

::v-deep .row-yellow {
  background-color: #fffbe0 !important;
}
</style>
